import { ContainerStatusShortCodeEnum } from "../enum/ContainerStatusShortCodeEnum";
import { JobTypeEnum } from "../enum/JobTypeEnum";
import StatusFlags from "../enum/StatusFlags";
import { ContainerMovementListItem } from "../model/ContainerMovementListItem";
import { AbstractContainerJobTypeHelper } from "./AbstractContainerJobTypeHelper";

export class ContainerStatusHelper {
    static determineContainerStatusFlag(gridSelected: ContainerMovementListItem[]): StatusFlags {
        const abstractContainerJobTypeHelper = new AbstractContainerJobTypeHelper()
        const statusFlags = {
            isReadyForPickup: false,
            isPack: false,
            isUnpack: false,
            none: true
        };

        if (gridSelected && gridSelected.length > 0) {
            const statusGroups = gridSelected.reduce((acc, record) => {
                if (record) {
                    const status = record.containerStatus!.transitStatus ?
                        record.containerStatus!.transitStatus!.code : 'invalid';

                    if (!acc[status]) {
                        acc[status] = [];
                    }

                    var jobTypeEnum: JobTypeEnum = JobTypeEnum[record.jobType as keyof typeof JobTypeEnum];
                    acc[status].push(jobTypeEnum);
                }
                return acc;
            }, {} as Record<string, JobTypeEnum[]>);

            const jobTypeSet = new Set<string>();

            // Only check for unique jobtypes
            gridSelected.forEach(record => {
                jobTypeSet.add(record.jobType);
            });

            // Check if there are more than 1 jobtype
            const hasMoreThanOneJobType = jobTypeSet.size > 1;

            // Filter out statuses that are not Packed nor Unpack nor ReadyForPickup
            const filteredStatuses = Object.keys(statusGroups).filter(status =>
                status !== ContainerStatusShortCodeEnum.Pack &&
                status !== ContainerStatusShortCodeEnum.Unpack &&
                status !== ContainerStatusShortCodeEnum.ReadyForPickup
            );

            const hasNonTransitStatuses = new Set(filteredStatuses).size > 0;
            const statuses = Object.keys(statusGroups);
            const hasMixedStatuses = statuses.length > 1;

            if (hasMixedStatuses && !hasNonTransitStatuses) {
                return statusFlags;
            }

            if (hasNonTransitStatuses) {
                statusFlags.none = false;
                return statusFlags;
            }

            // Check for 'Pack and Unpack' status group
            if (statusGroups[ContainerStatusShortCodeEnum.Pack] ||
                statusGroups[ContainerStatusShortCodeEnum.Unpack]) {
                statusFlags.isReadyForPickup = true;
                statusFlags.none = false;
            }

            if (hasMoreThanOneJobType) {
                statusFlags.none = true;
                return statusFlags;
            }

            // Check for 'ReadyForPickup' status group and job types
            if (statusGroups[ContainerStatusShortCodeEnum.ReadyForPickup]) {
                const jobTypes = statusGroups[ContainerStatusShortCodeEnum.ReadyForPickup];

                if (jobTypes.some(jobType => abstractContainerJobTypeHelper.isInboundJob(jobType))) {
                    statusFlags.isUnpack = true;
                    statusFlags.none = false;
                } else if (jobTypes.some(jobType => abstractContainerJobTypeHelper.isOutboundJob(jobType))) {
                    statusFlags.isPack = true;
                    statusFlags.none = false;
                }
            }

            // Default case when none of the conditions are met
            if (statusFlags.none && !(statusGroups[ContainerStatusShortCodeEnum.Pack] ||
                statusGroups[ContainerStatusShortCodeEnum.Unpack] ||
                statusGroups[ContainerStatusShortCodeEnum.ReadyForPickup])) {
                statusFlags.none = true;
            }
            return statusFlags;
        } else {
            return statusFlags;
        }
    }
}